function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 24C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12-5.373 12-12 12z",
  fill: "#201D1A"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M12 6a6 6 0 110 12 6 6 0 010-12zm0 3.64a2.36 2.36 0 10-.001 4.72A2.36 2.36 0 1012 9.64zm0 .36c1.103 0 2 .898 2 2 0 1.103-.897 2-2 2s-2-.897-2-2 .897-2 2-2zm0 .23c-.976 0-1.77.794-1.77 1.77s.794 1.77 1.77 1.77 1.77-.794 1.77-1.77-.794-1.77-1.77-1.77zm0 .77a1 1 0 110 2 1 1 0 010-2zm0 .241a.76.76 0 10.759.758.76.76 0 00-.76-.758zm.817-4.576a.922.922 0 00-1.067 1.057l.257 1.557s.257-.025.502.098l.889-1.394a.866.866 0 00-.581-1.318z"
});

var SvgMaster = function SvgMaster(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMaster, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/master.b98d1d75.svg";
export { ForwardRef as ReactComponent };